
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      {/* 背景视频 */}
      <div className="absolute inset-0 w-full h-full">
        <video
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="https://public.readdy.ai/ai/video_res/5d17a673-ea21-4515-8533-49adec2f364b.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* 内容容器 - 完全居中布局 */}
      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 sm:px-6 lg:px-[15%]">
        <div className="w-full max-w-6xl text-center text-white space-y-6 lg:space-y-8">
          {/* 主标题 */}
          <div className="space-y-3 lg:space-y-4">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#cc9966]" style={{ fontFamily: '"Trajan Pro", serif' }}>
              顺年陈
            </h1>
            <p className="text-sm sm:text-lg lg:text-xl font-light">
              新一代年份茶的标准制定者与引领者
            </p>
          </div>

          {/* 荣誉背书 - 核心展示区 */}
          <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-6 sm:p-8 lg:p-10 border border-[#cc9966]/30 mx-auto max-w-5xl">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#cc9966] mb-6 lg:mb-8">
              普洱茶年份茶全国销量第一品牌
            </h2>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
              {/* 销量第一证书 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-xl border border-[#cc9966]/20">
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">全国销量第一</h3>
                <p className="text-xs lg:text-sm text-center text-gray-200 leading-tight">
                  尚普咨询权威认证
                </p>
              </div>

              {/* 国宾伴手礼 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-xl border border-[#cc9966]/20">
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">国宾伴手礼</h3>
                <p className="text-xs lg:text-sm text-center text-gray-200 leading-tight">
                  丝路沿线指定
                </p>
              </div>

              {/* PICC承保 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-xl border border-[#cc9966]/20">
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">PICC承保</h3>
                <p className="text-xs lg:text-sm text-center text-gray-200 leading-tight">
                  产品责任险
                </p>
              </div>

              {/* 七星茶王奖 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-xl border border-[#cc9966]/20">
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">七星茶王奖</h3>
                <p className="text-xs lg:text-sm text-center text-gray-200 leading-tight">
                  珍稀级荣誉
                </p>
              </div>
            </div>
          </div>

          {/* 三真承诺 */}
          <div className="grid grid-cols-3 gap-4 lg:gap-8 max-w-3xl mx-auto">
            <div className="text-center space-y-2 lg:space-y-3">
              <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-white rounded-full mx-auto">
                <i className="ri-map-pin-fill text-base lg:text-lg text-[#cc9966]"></i>
              </div>
              <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966]">真产地</h3>
              <p className="text-xs lg:text-sm text-gray-200">云南核心产区</p>
            </div>
            <div className="text-center space-y-2 lg:space-y-3">
              <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-white rounded-full mx-auto">
                <i className="ri-time-fill text-base lg:text-lg text-[#cc9966]"></i>
              </div>
              <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966]">真年份</h3>
              <p className="text-xs lg:text-sm text-gray-200">证据链可追溯</p>
            </div>
            <div className="text-center space-y-2 lg:space-y-3">
              <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-white rounded-full mx-auto">
                <i className="ri-flask-fill text-base lg:text-lg text-[#cc9966]"></i>
              </div>
              <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966]">真转化</h3>
              <p className="text-xs lg:text-sm text-gray-200">科学仓贮管理</p>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动提示 */}
      <div className="absolute bottom-6 lg:bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
